import { render, staticRenderFns } from "./topbar.vue?vue&type=template&id=edd17b4c&"
import script from "./topbar.vue?vue&type=script&lang=js&"
export * from "./topbar.vue?vue&type=script&lang=js&"
import style0 from "./topbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports